export default __webpack_public_path__ + "bcd1740c6b76b05edfd814f1eaae27fe.png";